/**
 * @generated SignedSource<<461901de4dd7bc79ad00355560a28bb5>>
 * @relayHash 9739f0f71fb947308ea2e1e934f4c050
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5a43ae8c56bfe5af230ff64f69d82c8fc730834d10506cefa66b53c8ac72084c

import type { ConcreteRequest } from 'relay-runtime';
export type DevAiResourceType = "DEVAI_STANDARD" | "DEVAI_STANDARD_AND_JIRA" | "DEVAI_STANDARD_AND_JIRA_AND_CONFLUENCE" | "DEVAI_STANDARD_AND_JIRA_TRIAL" | "DEVAI_STANDARD_AND_JIRA_TRIAL_AND_CONFLUENCE" | "DEVAI_STANDARD_TRIAL" | "DEVAI_STANDARD_TRIAL_AND_JIRA" | "DEVAI_STANDARD_TRIAL_AND_JIRA_TRIAL" | "JIRA" | "JIRA_AND_CONFLUENCE" | "JIRA_TRIAL" | "JIRA_TRIAL_AND_CONFLUENCE" | "NO_ACTIVE_PRODUCT" | "ROVO_DEV_BETA" | "ROVO_DEV_EVERYWHERE" | "ROVO_DEV_STANDARD" | "ROVO_DEV_STANDARD_AND_JIRA" | "ROVO_DEV_STANDARD_AND_JIRA_AND_CONFLUENCE" | "ROVO_DEV_STANDARD_AND_JIRA_TRIAL" | "ROVO_DEV_STANDARD_AND_JIRA_TRIAL_AND_CONFLUENCE" | "ROVO_DEV_STANDARD_TRIAL" | "%future added value";
export type rovoDevEntitlementResourceQuery$variables = {
  cloudId: string;
};
export type rovoDevEntitlementResourceQuery$data = {
  readonly devai_rovodevIssueViewQuery: {
    readonly checks: {
      readonly entitlementType: DevAiResourceType;
      readonly userHasProductAccess: boolean | null;
    } | null;
    readonly isFeatureEnabled: boolean | null;
  } | null;
};
export type rovoDevEntitlementResourceQuery = {
  response: rovoDevEntitlementResourceQuery$data;
  variables: rovoDevEntitlementResourceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "DevAiRovoDevIssueViewResponse",
    "kind": "LinkedField",
    "name": "devai_rovodevIssueViewQuery",
    "plural": false,
    "selections": [
      {
        "concreteType": "DevAiEntitlementCheckResultResponse",
        "kind": "LinkedField",
        "name": "checks",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "entitlementType"
          },
          {
            "kind": "ScalarField",
            "name": "userHasProductAccess"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "isFeatureEnabled"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "rovoDevEntitlementResourceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rovoDevEntitlementResourceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "5a43ae8c56bfe5af230ff64f69d82c8fc730834d10506cefa66b53c8ac72084c",
    "metadata": {},
    "name": "rovoDevEntitlementResourceQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6577aea77cf228f78deb22b849b9b1d0";

export default node;
